import React, { useState, useRef } from 'react';
import { motion, AnimatePresence, useInView } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { usePricing } from '../contexts/PricingContext';
export function FAQ() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const {
    t
  } = useLanguage();
  const {
    price
  } = usePricing();
  // Replace price in text
  const replacePrice = (text: string) => {
    return text.replace(/€299|\$350|\$249|£299|\$399/g, price);
  };
  const faqItems = [{
    question: replacePrice(t('faq.q1')),
    answer: replacePrice(t('faq.a1'))
  }, {
    question: replacePrice(t('faq.q2')),
    answer: replacePrice(t('faq.a2'))
  }, {
    question: replacePrice(t('faq.q3')),
    answer: replacePrice(t('faq.a3'))
  }, {
    question: replacePrice(t('faq.q4')),
    answer: replacePrice(t('faq.a4'))
  }, {
    question: replacePrice(t('faq.q5')),
    answer: replacePrice(t('faq.a5'))
  }];
  const toggleItem = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="faq" ref={ref} className="relative w-full overflow-hidden px-4 py-24" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-170">
      <div className="relative z-10 mx-auto max-w-3xl" data-id="element-171">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="mb-12 text-center" data-id="element-172">
          <h2 className="mb-4 text-3xl font-bold md:text-4xl" style={{
          color: 'var(--text-primary)'
        }} data-id="element-173">
            {t('faq.title')} {t('faq.titleHighlight')}
          </h2>
          <p style={{
          color: 'var(--text-secondary)'
        }} data-id="element-174">
            {t('faq.subtitle')}
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-175">
          {faqItems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} data-id="element-176">
              <div className="rounded-2xl border overflow-hidden" style={{
            borderColor: 'var(--border)',
            backgroundColor: 'var(--bg-secondary)'
          }} data-id="element-177">
                <button onClick={() => toggleItem(index)} className="flex w-full items-center justify-between p-6 text-left transition-colors" aria-expanded={openIndex === index} data-id="element-178">
                  <h3 className="pr-4 font-semibold text-base" style={{
                color: 'var(--text-primary)'
              }} data-id="element-179">
                    {item.question}
                  </h3>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} className="flex-shrink-0" data-id="element-180">
                    <ChevronDownIcon className="h-5 w-5" style={{
                  color: 'var(--accent)'
                }} data-id="element-181" />
                  </motion.div>
                </button>

                <AnimatePresence initial={false} data-id="element-182">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-183">
                      <div className="border-t px-6 pb-6 pt-4" style={{
                  borderColor: 'var(--border)'
                }} data-id="element-184">
                        <p className="leading-relaxed" style={{
                    color: 'var(--text-secondary)'
                  }} data-id="element-185">
                          {item.answer}
                        </p>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}